export const SELECT_ACCOUNT_MIX_CONTAINER_DATA =
  'SELECT_ACCOUNT_MIX_CONTAINER_DATA';
export const SELECT_ACCOUNT_MIX_CONTAINER_DATA_ATTRIBUTE =
  'accountMixContainer';
export const RESET_ACCOUNT_MIX_CONTAINER_DATA =
  'RESET_ACCOUNT_MIX_CONTAINER_DATA';
